import gql from "graphql-tag";

const COMMON_QUERY = `
id
categoryId
branchLocationId
branchLocation {
    id
    name
}
processUsers {
    id
    username
    fullname
    email
  }
  createdAt
  updatedAt
`;

const createHelpdeskProcessUser = gql`
  mutation($categoryId: ID!, $branchLocationId: ID!, $processUserIds: [ID!]) {
    createHelpdeskProcessUser(
      data: {
        categoryId: $categoryId
        branchLocationId: $branchLocationId
        processUserIds: $processUserIds
      }
    ) {
      ${COMMON_QUERY}
    }
  }
`;

const updateHelpdeskProcessUser = gql`
  mutation($id: ID! $categoryId: ID, $branchLocationId: ID, $processUserIds: [ID!]) {
    updateHelpdeskProcessUser(
      id:$id
      data: {
        categoryId: $categoryId
        branchLocationId: $branchLocationId
        processUserIds: $processUserIds
      }
    ) {
      ${COMMON_QUERY}
    }
  }
`;

const getListHelpdeskProcessUser = gql`
  query($limit: Int, $page: Int, $categoryIds: [ID!] ) {
    getListHelpdeskProcessUser(
      paging: { limit: $limit, page: $page }
      filter: {categoryIds: $categoryIds}
    ) {
      ${COMMON_QUERY}
    }
  }
`;

const getDetailHelpdeskProcessUser = gql`
  query($id: ID!) {
    getDetailHelpdeskProcessUser(id: $id) {
        ${COMMON_QUERY}
    }
  }
`;

export default {
  createHelpdeskProcessUser,
  updateHelpdeskProcessUser,
  getListHelpdeskProcessUser,
  getDetailHelpdeskProcessUser,
};
